module.exports = __webpack_public_path__ + "static/colombus-bdee94a87f4c88814ad693b80bf6d261.png";